<template>
  <div class="qr-code-info">
    <div class="qrcode-box mb-20 ml-40">
      <vue-qr
        ref="Qrcode"
        :correctLevel="3"
        :text="qrCodeInfo"
        :size="size"
        :logoSrc="logoSrc"
        :logoScale="logoScale"
        :margin="marginInfo"
        :backgroundColor="backColor"
        :colorLight="foreColor"
        :bgSrc="bgSrc"
      ></vue-qr>
    </div>
    <div class="qrcode-box mb-20 ml-40" style="display: none">
      <vue-qr
        ref="oldQrcode"
        :correctLevel="3"
        :text="qrCodeInfo"
        :size="800"
        :logoSrc="logoSrc"
        :logoScale="logoScale"
        :margin="marginInfo"
        :backgroundColor="backColor"
        :colorLight="foreColor"
        :bgSrc="bgSrc"
      ></vue-qr>
    </div>
    <div class="qrcode-box mb-20 ml-40" id="qriously" style="display: none">
      <vue-qr
        ref="Qrcodetwo"
        :correctLevel="3"
        :text="qrCodeInfo"
        :margin="10"
        :size="800"
        :logoSrc="logoSrc"
        :logoScale="logoScale"
        :colorDark="'#000000'"
        :autoColor="true"
        :bgSrc="bgSrc"
      ></vue-qr>
      <!-- <qriously
        :value="qrCodeInfo"
        :size="800"
        :foregroundAlpha="1"
        :backgroundAlpha="0.2"
      /> -->
    </div>
    <span>左侧输入内容点击生成二维码</span>
    <div>
      <el-tabs>
        <el-tab-pane label="基本信息">
          <section class="base-info">
            <el-form label-width="85px" label-position="left">
              <el-form-item label="logo比例：">
                <el-radio-group v-model="faultTolerance">
                  <el-radio :label="0" value="0">10%</el-radio>
                  <el-radio :label="1" value="1">20%</el-radio>
                  <el-radio :label="2" value="2">30%</el-radio>
                  <el-radio :label="3" value="3">40%</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <el-form label-width="55px" label-position="left">
              <el-form-item label="尺寸：">
                <el-slider v-model="size" :step="40" :max="800"></el-slider>
              </el-form-item>
            </el-form>
          </section>
        </el-tab-pane>
        <el-tab-pane label="颜色">
          <div class="color-wrapper">
            <div>
              <label>前景：</label>
              <el-color-picker
                v-model="foreColor"
                size="small"
              ></el-color-picker>
            </div>
            <div>
              <label>背景：</label>
              <el-color-picker
                v-model="backColor"
                size="small"
              ></el-color-picker>
            </div>
          </div>
          <p class="mt-20 mb-40 notice">提示：前景色要比背景色深！</p>
        </el-tab-pane>
        <el-tab-pane label="嵌入LOGO">
          <el-upload
            class="upload-demo mb-40"
            ref="upload"
            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
            :data="uploadData"
            :action="fileUrl"
            :limit="1"
            :headers="getHeaders"
            :on-error="handleError"
            :before-upload="handleBeforeUpload"
            :on-success="handleSuccess"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              选择一个图片文件放在二维码中间
            </div>
          </el-upload>
        </el-tab-pane>
        <el-tab-pane label="模板">
          <el-radio-group v-model="formWork">
            <div class="mt-10 mb-20">
              <img
                src="@/assets/images/model_haier.jpg"
                width="100"
                height="100"
              />

              <img
                src="@/assets/images/model_ksd.jpg"
                width="100"
                height="100"
              />

              <img
                src="@/assets/images/model_tongshuai.jpg"
                width="100"
                height="100"
              />
            </div>
            <br />
            <el-radio :label="1" value="1">海尔</el-radio>
            <el-radio :label="2" value="2">卡萨帝</el-radio>
            <el-radio :label="3" value="3">统帅</el-radio>
          </el-radio-group>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import Setting from "@/config/setting";
import VueCookie from "@/config/util.cookies";

export default {
  components: {
    VueQr
  },
  props: {
    dataInfo: {
      type: Object
    }
  },
  watch: {
    dataInfo: {
      handler(val) {
        let _this = this;
        _this.foreColor = val.foreColor;
        _this.backColor = val.backColor;
        if (val.logoSrc !== null && val.logoSrc !== "") {
          _this.logoSrc = val.logoSrc;
        }
        if (val.formWork !== null && val.formWork !== "") {
          _this.formWork = val.formWork;
        }
        if (val.faultToleRance !== null && val.faultToleRance !== "") {
          _this.faultToleRance = val.faultToleRance;
        }
        _this.size = val.size;
        _this.qrCodeInfo = val.data;
      },
      deep: true
    },
    faultTolerance(val) {
      let _this = this;
      if (val === 0) {
        _this.logoScale = 0.2;
      } else if (val === 1) {
        _this.logoScale = 0.3;
      } else if (val === 2) {
        _this.logoScale = 0.4;
      } else {
        _this.logoScale = 0.5;
      }
    },
    formWork(val) {
      let _this = this;
      if (val === 1) {
        _this.bgSrc = require("@/assets/images/model_haier.jpg");
      } else if (val === 2) {
        _this.bgSrc = require("@/assets/images/model_ksd.jpg");
      } else {
        _this.bgSrc = require("@/assets/images/model_tongshuai.jpg");
      }
    }
  },
  data() {
    return {
      fileUrl: Setting.fileUrl,
      backgroundAlpha: 10,
      marginInfo: 10,
      foreColor: "#FFFFFF",
      backColor: "#FFFFFF",
      logoSrc: "",
      bgSrc: "",
      logoScale: 0.4,
      size: 200,
      qrCodeInfo: "",
      faultTolerance: 2,
      formWork: "",
      fileInfo: "",
      uploadData: {
        fileName: ""
      },
      getHeaders: {
        Authorization: "Bearer " + VueCookie.get("token")
      }
    };
  },
  methods: {
    handleError() {
      let _this = this;
      _this.$message({
        message: "文件上传失败!",
        type: "warning"
      });
    },
    handleSuccess(response, file, fileList) {
      let _this = this;
      if (response.status == 200) {
        _this.logoSrc = response.data;
        _this.$message({
          message: "文件上传成功!",
          type: "success"
        });
      } else {
        _this.$message({
          message: "文件上传失败!",
          type: "warning"
        });
      }
    },
    handleBeforeUpload(file) {
      let _this = this;
      _this.uploadData.fileName = file.name;
    },
    createCode(value, type) {
      let _this = this;
      if (type === 1) {
        _this.handleWebSite(value);
      } else if (type === 2) {
        _this.handleCarInfo(value);
      } else if (type === 3) {
        _this.handleFile(value);
      } else {
        _this.handleText(value);
      }
    },
    handleText(value) {
      let _this = this;
      _this.qrcodeData = value;
      //二维码数据
      _this.qrCodeInfo = _this.qrcodeData.content;
      //开始数据保存
      _this.qrcodeData.logo = _this.logoSrc;
      _this.qrcodeData.size = _this.size;
      _this.qrcodeData.foreColor = _this.foreColor;
      _this.qrcodeData.backColor = _this.backColor;
      _this.qrcodeData.formWork = _this.formWork;
      _this.qrcodeData.faultToleRance = _this.faultTolerance;
      let param = {
        url: "/api/textAndFile/saveTextInfo",
        params: _this.qrcodeData
      };
      _this.$Api
        .post(param.url, param.params)
        .then(response => {
          if (response.status === 200) {
            _this.$message({
              message: "二维码生成成功!",
              type: "success"
            });
            _this.$emit("getTextInfoList");
          } else {
            _this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        })
        .catch(err => {});
    },
    handleFile(value) {
      let _this = this;
      _this.qrcodeData = value;
      //二维码数据
      _this.qrCodeInfo = _this.qrcodeData.content;
      //开始数据保存
      _this.qrcodeData.logo = _this.logoSrc;
      _this.qrcodeData.size = _this.size;
      _this.qrcodeData.foreColor = _this.foreColor;
      _this.qrcodeData.backColor = _this.backColor;
      _this.qrcodeData.formWork = _this.formWork;
      _this.qrcodeData.faultToleRance = _this.faultTolerance;
      let param = {
        url: "/api/textAndFile/saveFileInfo",
        params: _this.qrcodeData
      };
      _this.$Api
        .post(param.url, param.params)
        .then(response => {
          if (response.status === 200) {
            _this.$message({
              message: "二维码生成成功!",
              type: "success"
            });
            _this.$emit("getFileInfoList");
          } else {
            _this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        })
        .catch(err => {});
    },
    handleWebSite(value) {
      //开始进行生成二维码处理
      let _this = this;
      _this.qrcodeData = value;
      let marketingUrl = _this.qrcodeData.marketingUrl;
      let urlStr = marketingUrl.charAt(marketingUrl.length - 1);
      if (urlStr === "/") {
        _this.qrcodeData.marketingUrl = _this.qrcodeData.marketingUrl.slice(
          0,
          _this.qrcodeData.marketingUrl.length - 1
        );
      }
      if (marketingUrl.indexOf("?") === -1) {
        //不包含参数
        marketingUrl = marketingUrl + "?system=qrcode";
      }
      let paramUrl = "";
      if (
        _this.qrcodeData.marketingMediaName !== "" &&
        _this.qrcodeData.marketingMediaName !== undefined &&
        _this.qrcodeData.marketingMediaName !== null
      ) {
        paramUrl =
          paramUrl + "&utm_source=" + _this.qrcodeData.marketingMediaName;
      }
      if (
        _this.qrcodeData.marketingMediaChannel !== "" &&
        _this.qrcodeData.marketingMediaChannel !== undefined &&
        _this.qrcodeData.marketingMediaChannel !== null
      ) {
        paramUrl =
          paramUrl + "&utm_channel=" + _this.qrcodeData.marketingMediaChannel;
      }
      //开始数据保存
      _this.qrcodeData.logo = _this.logoSrc;
      _this.qrcodeData.size = _this.size;
      _this.qrcodeData.foreColor = _this.foreColor;
      _this.qrcodeData.backColor = _this.backColor;
      _this.qrcodeData.formWork = _this.formWork;
      _this.qrcodeData.faultToleRance = _this.faultTolerance;
      let param = {
        url: "/api/marketing/saveMarketingInfo",
        params: _this.qrcodeData
      };
      _this.$Api
        .post(param.url, param.params)
        .then(response => {
          if (response.status === 200) {
            //开始进行二维码数据处理
            _this.qrCodeInfo = response.data.codeContent;
            _this.$message({
              message: "二维码生成成功!",
              type: "success"
            });
          } else {
            _this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        })
        .catch(err => {});
    },
    handleCarInfo(value) {
      //开始进行生成二维码处理
      let _this = this;
      _this.qrcodeData = value;
      let urlStr = _this.qrcodeData.cardUrl.charAt(
        _this.qrcodeData.cardUrl.length - 1
      );
      if (urlStr === "/") {
        _this.qrcodeData.cardUrl = _this.qrcodeData.cardUrl.slice(
          0,
          _this.qrcodeData.cardUrl.length - 1
        );
      }
      //开始进行二维码数据处理
      let jingioid =
        "BEGIN:VCARD\n" +
        "VERSION:3.0\n" +
        "FN:" +
        _this.qrcodeData.cardName +
        "\n" +
        "TITLE:" +
        _this.qrcodeData.cardPost +
        "\n" +
        "TEL;CELL;VOICE:" +
        _this.qrcodeData.cardMobile +
        "\n" +
        "TEL;WORK;VOICE:" +
        _this.qrcodeData.cardQuhao +
        "-" +
        _this.qrcodeData.cardPhone +
        "\n" +
        "EMAIL;PREF;INTERNET:" +
        _this.qrcodeData.cardEmail +
        "\n" +
        "ADR:" +
        _this.qrcodeData.cardAddress +
        "\n" +
        "NOTE:" +
        _this.qrcodeData.cardRemark +
        "\n" +
        "END:VCARD";
      //二维码数据
      _this.qrCodeInfo = jingioid;
      //开始数据保存
      _this.qrcodeData.logo = _this.logoSrc;
      _this.qrcodeData.size = _this.size;
      _this.qrcodeData.foreColor = _this.foreColor;
      _this.qrcodeData.backColor = _this.backColor;
      _this.qrcodeData.formWork = _this.formWork;
      _this.qrcodeData.faultToleRance = _this.faultTolerance;
      _this.qrcodeData.jingioid = jingioid;
      let param = {
        url: "/api/card/saveCardInfo",
        params: _this.qrcodeData
      };
      _this.$Api
        .post(param.url, param.params)
        .then(response => {
          if (response.status === 200) {
            _this.$message({
              message: "二维码生成成功!",
              type: "success"
            });
            _this.$emit("getCardList");
          } else {
            _this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        })
        .catch(err => {});
    },
    // downloadQrcode() {
    //   let _this = this;
    //   if (_this.qrCodeInfo === "") {
    //     _this.$message.error("尚未生成二维码,暂不允许下载!");
    //   } else {
    //     let type = "image/png";
    //     let canvas = document.querySelector("#qriously canvas");
    //     let imgSrc = canvas.toDataURL(type);
    //     let a = document.createElement("a");
    //     let event = new MouseEvent("click");
    //     a.download = "二维码";
    //     a.href = imgSrc;
    //     console.log(`output->`,imgSrc,_this.qrCodeInfo)
    //     a.dispatchEvent(event);
    //   }
    // },
    downloadQrcode() {
      let _this = this;
      if (_this.qrCodeInfo === "") {
        _this.$message.error("尚未生成二维码,暂不允许下载!");
      } else {
        const iconUrl = this.$refs.Qrcodetwo.$el.src;
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = "二维码";
        a.href = iconUrl;
        a.dispatchEvent(event);
      }
    },
    downloadOldQrcode() {
      let _this = this;
      if (_this.qrCodeInfo === "") {
        _this.$message.error("尚未生成二维码,暂不允许下载!");
      } else {
        const iconUrl = this.$refs.oldQrcode.$el.src;
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        a.download = "二维码";
        a.href = iconUrl;
        a.dispatchEvent(event);
      }
    },
    handleExceed() {},
    beforeRemove(file) {}
  }
};
</script>

<style lang="sass" scoped>
.qr-code-info
    display: flex
    justify-content: center
    flex-direction: column
    align-items: center

    .el-tabs
        min-width: 360px

    .qrcode-box
        width: 200px
        height: 200px
        border-radius: 4px
        border: 1px solid #b6b6b6
        display: flex
        align-items: center
        justify-content: center

        & > span
            text-align: center
            font-size: 14px

    .base-info
        .el-slider
            width: 320px

    .color-wrapper
        display: flex
        align-items: center

        & > div:first-child
            margin-right: 50px

        & > div
            display: flex
            align-items: center

    .notice
        font-size: 13px

    .footer-btn
        display: flex
        justify-content: center

        button
            width: 60%
</style>
